<div class="close-button" (click)="close()"></div>
<div class="email-dialog">
    <p class="dialog-h2">Email has been sent</p>
    <p class="dialog-text">An email has been sent to <b>{{data.email}}</b> and you have been copied in to the email for
        reference.</p>
    <p class="dialog-h2">What happens next?</p>
    <p class="dialog-text"> <b>{{data.name}}</b> needs to continue with the application using the link provided in the email.
    </p>
</div>